export enum LoginView {
    SIGN_IN = 'signIn',
    SIGN_UP = 'signUp',
    RECOVER = 'recover'
}
